// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"173":"38653b84","218":"e82d8278","480":"38653b84","745":"38653b84","861":"38653b84"}[chunkId] + ".chunk.css";
};